import React from 'react';
import config from '../../../config.json';
import { loggedIn, logout } from '../../models/auth.js';

const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKOFICCE_V2 = config.backofficeV2[env];

export default class Logout extends React.Component {
  componentDidMount() {
    logout();
    this.state = {
      loggedIn: loggedIn(),
    };
    window.location.href = `${BACKOFICCE_V2}/logout-v2`;
  }

  render() {
    return (
      <div
        className="col-sm-offset-2 col-sm-8 alert alert-danger"
        role="alert"
      >
        <span
          className="glyphicon glyphicon-exclamation-sign"
          aria-hidden="true"
        ></span>
        <span className="sr-only">Error:</span>
        Usuário desconectado
      </div>
    );
  }
}

